module.exports = __webpack_public_path__ + "common/icon-uploadFile-cloud-d0bb98c2f5dc74b4efc00db1147fac88.svg";